var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      attrs: { type: "hidden", name: "invoice_items" },
      domProps: { value: JSON.stringify(_vm.services) },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "portlet light portlet-fit invoice-details-portlet",
        on: { keydown: _vm.downKeyAdd },
      },
      [
        !_vm.formMode
          ? _c("div", { staticClass: "portlet-title" }, [
              _c("div", { staticClass: "caption" }, [
                _c("i", { staticClass: "fa fa-list" }),
                _vm._v(" "),
                _c("span", { staticClass: "caption-subject bold uppercase" }, [
                  _vm._v("Services et pièces"),
                ]),
                _vm._v(" "),
                !_vm.readOnly
                  ? _c("span", { staticClass: "invoice-save-controls" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          attrs: {
                            type: "button",
                            title: "Actualiser les détails",
                            "aria-label": "Actualiser les détails",
                            disabled: _vm.gridReloading,
                          },
                          on: { click: _vm.reloadDetailGrid },
                        },
                        [_c("i", { staticClass: "fa fa-refresh" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          attrs: {
                            type: "button",
                            title: "Enregistrer tout",
                            "aria-label": "Enregistrer tout",
                            disabled: _vm.pendingSaveCount > 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveItems()
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-save" })]
                      ),
                      _vm._v(" "),
                      _vm.pendingSaveCount === 0 && _vm.saveCycleSucceeded
                        ? _c(
                            "span",
                            {
                              staticClass: "invoice-saved-indicator",
                              attrs: {
                                title: "Enregistré",
                                "aria-label": "Enregistré",
                              },
                            },
                            [_c("i", { staticClass: "fa fa-check" })]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "portlet-body" }, [
          _vm.loading
            ? _c("div", [_vm._m(1)])
            : _c("div", [
                !_vm.readOnly
                  ? _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "element-data" }, [
                            _vm.allowEditVehicle
                              ? _c("a", {
                                  staticClass: "action-modify-vehicle",
                                  attrs: {
                                    href: "javascript:;",
                                    id: "invoice_vehicle_display",
                                    "vehicle-id": this.vehicleId,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.allowEditVehicle
                              ? _c(
                                  "div",
                                  {
                                    attrs: {
                                      id: "invoice_vehicle_display",
                                      "vehicle-id": this.vehicleId,
                                    },
                                  },
                                  [_vm._v(_vm._s(this.vehicleName))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm purple hidden",
                                attrs: { id: "action-add-service-tire" },
                                on: { click: _vm.actionaddservicetire },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-circle-o-notch",
                                }),
                                _vm._v(" Service de pneu "),
                                _c("i", { staticClass: "fa fa-plus" }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                id: "data-add-service-tire",
                                value: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm purple hidden",
                                attrs: { id: "action-add-service-oil" },
                                on: { click: _vm.actionaddserviceoil },
                              },
                              [
                                _c("i", { staticClass: "fa fa-tint" }),
                                _vm._v(" Service d'huile "),
                                _c("i", { staticClass: "fa fa-plus" }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                id: "data-add-service-oil",
                                value: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                id: "data-add-service-oil-qty",
                                value: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                id: "data-add-part-oil-filter",
                                value: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm purple hidden",
                                attrs: { id: "action-add-service-storage" },
                                on: { click: _vm.actionaddservicestorage },
                              },
                              [
                                _c("i", { staticClass: "fa fa-archive" }),
                                _vm._v(" Service d'entreposage "),
                                _c("i", { staticClass: "fa fa-plus" }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                id: "data-add-service-storage",
                                value: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm purple hidden",
                                attrs: { id: "action-add-service-tpms" },
                                on: { click: _vm.actionaddservicetpms },
                              },
                              [
                                _c("i", { staticClass: "fa fa-tachometer" }),
                                _vm._v(" Service TPMS "),
                                _c("i", { staticClass: "fa fa-plus" }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                id: "data-add-service-tpms",
                                value: "",
                              },
                            }),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "invoice-details-grid-wrapper" }, [
                  _vm.gridReloading
                    ? _c(
                        "div",
                        { staticClass: "invoice-details-grid-overlay" },
                        [_vm._m(2)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "table",
                    {
                      staticClass: "table table-bordered",
                      staticStyle: { "margin-bottom": "5px" },
                      attrs: { id: "invoice-details-table" },
                    },
                    [
                      _c("thead", [
                        _c("tr", [
                          !_vm.readOnly ? _c("th", [_vm._v(" ")]) : _vm._e(),
                          _vm._v(" "),
                          !_vm.readOnly ? _c("th", [_vm._v(" ")]) : _vm._e(),
                          _vm._v(" "),
                          _c("th", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { width: "470px" } }, [
                            _vm._v("Services et pièces"),
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Description")]),
                          _vm._v(" "),
                          !_vm.isSoumission
                            ? _c(
                                "th",
                                {
                                  staticClass: "soumission-compact-col",
                                  staticStyle: { width: "62px" },
                                },
                                [_vm._v("Commander")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "width-min-nowrap",
                              staticStyle: { width: "70px" },
                            },
                            [_vm._v("Quantité")]
                          ),
                          _vm._v(" "),
                          _vm.isSoumission
                            ? _c(
                                "th",
                                {
                                  staticClass:
                                    "width-min-nowrap soumission-compact-col",
                                  staticStyle: {
                                    "max-width": "62px",
                                    width: "62px",
                                  },
                                },
                                [_vm._v("Groupe")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSoumission
                            ? _c(
                                "th",
                                {
                                  staticClass:
                                    "width-min-nowrap text-right soumission-compact-col",
                                  staticStyle: { width: "62px" },
                                },
                                [
                                  _vm._v("$ suggéré"),
                                  _c("wbr"),
                                  _vm._v("unitaire"),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSoumission
                            ? _c(
                                "th",
                                {
                                  staticClass:
                                    "width-min-nowrap text-right soumission-compact-col",
                                  staticStyle: { width: "62px" },
                                },
                                [
                                  _vm._v("$ coutant"),
                                  _c("wbr"),
                                  _vm._v("unitaire"),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSoumission
                            ? _c(
                                "th",
                                {
                                  staticClass:
                                    "width-min-nowrap text-right soumission-compact-col",
                                  staticStyle: { width: "62px" },
                                },
                                [_vm._v("Profit $ min")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSoumission
                            ? _c(
                                "th",
                                {
                                  staticClass:
                                    "width-min-nowrap text-right soumission-compact-col",
                                  staticStyle: { width: "62px" },
                                },
                                [_vm._v("Profit %"), _c("wbr"), _vm._v("min")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticClass: "width-min-nowrap text-right" },
                            [_vm._v("Prix unitaire")]
                          ),
                          _vm._v(" "),
                          _vm.isSoumission
                            ? _c(
                                "th",
                                {
                                  staticClass:
                                    "width-min-nowrap text-right soumission-compact-col",
                                  staticStyle: { width: "62px" },
                                },
                                [_vm._v("Profit %"), _c("wbr"), _vm._v("réel")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticClass: "width-min-nowrap text-right" },
                            [_vm._v("Sous-Total")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass:
                                "width-min-nowrap soumission-compact-col text-right",
                            },
                            [_vm._v("T.V. Pneu")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticClass: "width-min-nowrap text-right" },
                            [_vm._v("Total")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          attrs: { tag: "tbody", handle: ".draggable-handle" },
                          on: {
                            update: function ($event) {
                              return _vm.handleChange()
                            },
                          },
                          model: {
                            value: _vm.items,
                            callback: function ($$v) {
                              _vm.items = $$v
                            },
                            expression: "items",
                          },
                        },
                        [
                          _vm._l(_vm.items, function (item, index) {
                            return [
                              item.is_subtotal_row
                                ? _c(
                                    "tr",
                                    {
                                      key: `subtotal-${index}`,
                                      staticClass: "item-row is-subtotal-row",
                                    },
                                    [
                                      !_vm.readOnly
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap draggable-handle",
                                              staticStyle: {
                                                padding: "3px 8px",
                                                "vertical-align": "middle",
                                                "font-size": "22px",
                                                cursor: "move",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-bars",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.readOnly
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap text-center",
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-circle btn-icon-only btn-default tooltips mr-0",
                                                  attrs: {
                                                    "data-container": "body",
                                                    "data-placement": "top",
                                                    "data-original-title":
                                                      "Supprimer",
                                                    href: "javascript:;",
                                                    title: "Supprimer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeSubtotal(
                                                        item.service_index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "icon-trash",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "width-min-nowrap" },
                                        [_vm._v(" ")]
                                      ),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "bold" }, [
                                        _vm._v("Sous-total"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "background-color": "inherit",
                                          },
                                          attrs: {
                                            colspan: _vm.subtotalGapColspan - 2,
                                          },
                                        },
                                        [_vm._v(" ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "width-min-nowrap text-right",
                                          staticStyle: { "font-size": "12px" },
                                        },
                                        [
                                          _vm._v(
                                            "TPS : " +
                                              _vm._s(
                                                _vm.getSubTotalBreakTax(
                                                  index,
                                                  "tps"
                                                )
                                              ) +
                                              " $"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "width-min-nowrap text-right",
                                          staticStyle: { "font-size": "12px" },
                                        },
                                        [
                                          _vm._v(
                                            "TVQ : " +
                                              _vm._s(
                                                _vm.getSubTotalBreakTax(
                                                  index,
                                                  "tvq"
                                                )
                                              ) +
                                              " $"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "width-min-nowrap text-right bold",
                                          staticStyle: { "min-width": "100px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getSubTotalBreakSubtotal(
                                                index
                                              )
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "width-min-nowrap text-right",
                                          staticStyle: { width: "50px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getSubTotalBreakTireTax(index)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "width-min-nowrap text-right bold",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getSubTotalBreakTotal(index)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "tr",
                                    {
                                      key: `item-${index}`,
                                      staticClass: "item-row",
                                      class: {
                                        "is-done":
                                          item.invoice_detail_is_done &&
                                          item.part_index === undefined,
                                        "is-service":
                                          item.part_index === undefined,
                                        "is-unselected":
                                          _vm.isSoumission &&
                                          item.part_index !== undefined &&
                                          (!item.invoice_detail_selected ||
                                            _vm.isCorePart(item)),
                                      },
                                    },
                                    [
                                      !_vm.readOnly
                                        ? _c(
                                            "td",
                                            {
                                              staticClass: "width-min-nowrap",
                                              class: {
                                                "draggable-handle":
                                                  item.part_index === undefined,
                                              },
                                              staticStyle: {
                                                padding: "3px 8px",
                                                "vertical-align": "middle",
                                                "font-size": "22px",
                                                cursor: "move",
                                              },
                                            },
                                            [
                                              item.part_index === undefined
                                                ? _c("i", {
                                                    staticClass: "fa fa-bars",
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.readOnly &&
                                      item.invoice_detail_is_garanteed != 0
                                        ? _c("td", [_vm._v("G")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.readOnly &&
                                      item.invoice_detail_is_garanteed == 0
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap text-center",
                                              style: {
                                                padding:
                                                  item.part_index === undefined
                                                    ? "8px"
                                                    : "3px 8px",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                item.part_index !== undefined &&
                                                _vm.isSoumission &&
                                                !_vm.isCorePart(item)
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "soumission-part-selected tooltips",
                                                        attrs: {
                                                          "data-container":
                                                            "body",
                                                          "data-placement":
                                                            "top",
                                                          "data-original-title":
                                                            "Inclure cette pièce dans la soumission",
                                                          title: "Choisi",
                                                        },
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                item.invoice_detail_selected,
                                                              expression:
                                                                "item.invoice_detail_selected",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                item.invoice_detail_selected
                                                              )
                                                                ? _vm._i(
                                                                    item.invoice_detail_selected,
                                                                    null
                                                                  ) > -1
                                                                : item.invoice_detail_selected,
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    item.invoice_detail_selected,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      null,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      _vm.$set(
                                                                        item,
                                                                        "invoice_detail_selected",
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        )
                                                                      )
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      _vm.$set(
                                                                        item,
                                                                        "invoice_detail_selected",
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          )
                                                                      )
                                                                  }
                                                                } else {
                                                                  _vm.$set(
                                                                    item,
                                                                    "invoice_detail_selected",
                                                                    $$c
                                                                  )
                                                                }
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.handleChange(
                                                                  item
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v("Choisi"),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.part_index !== undefined &&
                                                _vm.isSoumission &&
                                                _vm.isCorePart(item)
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "soumission-core-label",
                                                      },
                                                      [
                                                        _vm._v("Consigne"),
                                                        _c("br"),
                                                        _vm._v(
                                                          "non comptabilisée"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.part_index !== undefined &&
                                                !_vm.isSoumission
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn btn-circle btn-icon-only btn-default tooltips mr-0",
                                                        attrs: {
                                                          "data-container":
                                                            "body",
                                                          "data-placement":
                                                            "top",
                                                          "data-original-title":
                                                            "Retourner pièce",
                                                          href: "javascript:;",
                                                          title:
                                                            "Retourner pièce",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.returnPart(
                                                              item.service_index,
                                                              item.part_index,
                                                              _vm.itemInventoryCount(
                                                                item
                                                              )
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "icon-action-undo",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.part_index !== undefined &&
                                                _vm.isSoumission
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn btn-circle btn-icon-only btn-default tooltips mr-0",
                                                        attrs: {
                                                          "data-container":
                                                            "body",
                                                          "data-placement":
                                                            "top",
                                                          "data-original-title":
                                                            "Supprimer",
                                                          href: "javascript:;",
                                                          title: "Supprimer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeSoumissionPart(
                                                              item.service_index,
                                                              item.part_index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "icon-trash",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.part_index === undefined ||
                                                !_vm.isSoumission
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn btn-circle btn-icon-only btn-default tooltips mr-0",
                                                        attrs: {
                                                          "data-container":
                                                            "body",
                                                          "data-placement":
                                                            "top",
                                                          "data-original-title":
                                                            "Retourner dans l'inventaire",
                                                          href: "javascript:;",
                                                          title:
                                                            item.part_index ===
                                                            undefined
                                                              ? "Supprimer"
                                                              : "Retourner dans l'inventaire",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeItem(
                                                              item.service_index,
                                                              item.part_index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        item.part_index ===
                                                        undefined
                                                          ? _c("i", {
                                                              staticClass:
                                                                "icon-trash",
                                                            })
                                                          : _vm._e(),
                                                        item.part_index !==
                                                        undefined
                                                          ? _c("span", [
                                                              _vm._v("I"),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                              _vm._v(" "),
                                              item.part_index === undefined &&
                                              !_vm.isSoumission
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                      staticStyle: {
                                                        "margin-top": "5px",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Fait "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              item.invoice_detail_is_done,
                                                            expression:
                                                              "item.invoice_detail_is_done",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            Array.isArray(
                                                              item.invoice_detail_is_done
                                                            )
                                                              ? _vm._i(
                                                                  item.invoice_detail_is_done,
                                                                  null
                                                                ) > -1
                                                              : item.invoice_detail_is_done,
                                                        },
                                                        on: {
                                                          change: [
                                                            function ($event) {
                                                              var $$a =
                                                                  item.invoice_detail_is_done,
                                                                $$el =
                                                                  $event.target,
                                                                $$c =
                                                                  $$el.checked
                                                                    ? true
                                                                    : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      item,
                                                                      "invoice_detail_is_done",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      item,
                                                                      "invoice_detail_is_done",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  item,
                                                                  "invoice_detail_is_done",
                                                                  $$c
                                                                )
                                                              }
                                                            },
                                                            function ($event) {
                                                              return _vm.handleChange(
                                                                item
                                                              )
                                                            },
                                                          ],
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.part_index === undefined &&
                                              _vm.isSoumission
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                      staticStyle: {
                                                        "margin-top": "5px",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Sél. "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        staticClass:
                                                          "invoice_detail_is_selected",
                                                        attrs: {
                                                          type: "checkbox",
                                                          id: `invoice_detail_is_selected[${
                                                            item.service_index ??
                                                            0
                                                          }]`,
                                                          checked: "",
                                                        },
                                                        domProps: {
                                                          value:
                                                            item.invoice_detail_id ??
                                                            0,
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "width-min-nowrap",
                                          staticStyle: {
                                            "vertical-align": "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  item.part_index === undefined
                                                    ? "Service"
                                                    : "Pièce",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    item.part_index ===
                                                      undefined
                                                      ? "S"
                                                      : "P"
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "input",
                                          staticStyle: {
                                            width: "400px",
                                            "min-width": "400px",
                                          },
                                        },
                                        [
                                          !_vm.readOnly &&
                                          item.invoice_detail_is_garanteed == 0
                                            ? _c(
                                                "div",
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          item.invoice_detail_invoice_id,
                                                        expression:
                                                          "item.invoice_detail_invoice_id",
                                                      },
                                                    ],
                                                    attrs: { type: "hidden" },
                                                    domProps: {
                                                      value:
                                                        item.invoice_detail_invoice_id,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          item,
                                                          "invoice_detail_invoice_id",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          item.invoice_detail_service_id,
                                                        expression:
                                                          "item.invoice_detail_service_id",
                                                      },
                                                    ],
                                                    attrs: { type: "hidden" },
                                                    domProps: {
                                                      value:
                                                        item.invoice_detail_service_id,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          item,
                                                          "invoice_detail_service_id",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  item.type == "service"
                                                    ? _c("select-two-items", {
                                                        ref: `select2-service-${item.service_index}`,
                                                        refInFor: true,
                                                        attrs: {
                                                          endpoint:
                                                            _vm.itemEndpoint,
                                                          type: item.type,
                                                          "initial-value": item
                                                            .invoice_detail_item
                                                            .id
                                                            ? item.invoice_detail_item.id.toString()
                                                            : "",
                                                          "initial-display":
                                                            item
                                                              .invoice_detail_item
                                                              .text,
                                                          "add-form-base-end-point":
                                                            _vm.baseEndpoint +
                                                            "service/add",
                                                          "add-form-title":
                                                            "Ajout d'un service",
                                                          "add-form-selector":
                                                            "#form_service",
                                                          "add-text-input-selector":
                                                            "#service_name",
                                                          "edit-form-base-end-point":
                                                            _vm.baseEndpoint +
                                                            "service/edit",
                                                          "edit-form-title":
                                                            "Modifier un service",
                                                          "edit-form-selector":
                                                            "#form_service",
                                                          "edit-text-input-selector":
                                                            "#service_name",
                                                          "allow-add":
                                                            _vm.allowAddServices,
                                                          "allow-edit":
                                                            _vm.allowEditServices,
                                                          dropdownParent:
                                                            _vm.formMode
                                                              ? ".modal-invoice"
                                                              : "body",
                                                        },
                                                        on: {
                                                          selected: function (
                                                            $event
                                                          ) {
                                                            return _vm.onSelect(
                                                              item.service_index,
                                                              item.part_index,
                                                              $event
                                                            )
                                                          },
                                                          clear: function (
                                                            $event
                                                          ) {
                                                            return _vm.onClear(
                                                              item.service_index,
                                                              item.part_index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.invoice_detail_item,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "invoice_detail_item",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.invoice_detail_item",
                                                        },
                                                      })
                                                    : item.type == "part"
                                                    ? _c("select-two-items", {
                                                        ref: `select2-part-${item.service_index}-${item.part_index}`,
                                                        refInFor: true,
                                                        attrs: {
                                                          endpoint:
                                                            _vm.itemEndpoint,
                                                          type: item.type,
                                                          "initial-value": item
                                                            .invoice_detail_item
                                                            .id
                                                            ? item.invoice_detail_item.id.toString()
                                                            : "",
                                                          "initial-display":
                                                            item
                                                              .invoice_detail_item
                                                              .text,
                                                          "add-form-base-end-point":
                                                            _vm.baseEndpoint +
                                                            "part/add",
                                                          "add-form-title":
                                                            "Ajout d'une pièce",
                                                          "add-form-selector":
                                                            "#form_part",
                                                          "add-text-input-selector":
                                                            "#part_name",
                                                          "edit-form-base-end-point":
                                                            _vm.baseEndpoint +
                                                            "part/edit",
                                                          "edit-form-title":
                                                            "Modifier une pièce",
                                                          "edit-form-selector":
                                                            "#form_part",
                                                          "edit-text-input-selector":
                                                            "#part_name",
                                                          "allow-add":
                                                            _vm.allowAddParts,
                                                          "allow-edit":
                                                            _vm.allowEditParts,
                                                          "allow-quick-add":
                                                            _vm.allowAddParts,
                                                          dropdownParent:
                                                            _vm.formMode
                                                              ? ".modal-invoice"
                                                              : "body",
                                                        },
                                                        on: {
                                                          selected: function (
                                                            $event
                                                          ) {
                                                            _vm.onSelect(
                                                              item.service_index,
                                                              item.part_index,
                                                              $event
                                                            )
                                                            _vm.focus(index)
                                                          },
                                                          clear: function (
                                                            $event
                                                          ) {
                                                            return _vm.onClear(
                                                              item.service_index,
                                                              item.part_index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.invoice_detail_item,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "invoice_detail_item",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.invoice_detail_item",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.part_index === undefined
                                                    ? _c(
                                                        "small",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href: "javascript:;",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.addPart(
                                                                      item.service_index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+ Ajouter pièce"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              " (" +
                                                                _vm._s(
                                                                  item.parts
                                                                    .length
                                                                ) +
                                                                "  " +
                                                                _vm._s(
                                                                  item.parts
                                                                    .length > 1
                                                                    ? "pièces"
                                                                    : "pièce"
                                                                ) +
                                                                ")"
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.invoice_detail_item
                                                          .text
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "input soumission-compact-col",
                                        },
                                        [
                                          !_vm.readOnly &&
                                          item.invoice_detail_is_garanteed == 0
                                            ? _c("div", [
                                                item.part_index === undefined
                                                  ? _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            item.invoice_detail_description,
                                                          expression:
                                                            "item.invoice_detail_description",
                                                        },
                                                      ],
                                                      ref: "description-box",
                                                      refInFor: true,
                                                      staticClass:
                                                        "form-control",
                                                      staticStyle: {
                                                        width: "100%",
                                                        "min-height": "35px",
                                                        resize: "vertical",
                                                      },
                                                      domProps: {
                                                        value:
                                                          item.invoice_detail_description,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleChange(
                                                            item
                                                          )
                                                        },
                                                        input: [
                                                          function ($event) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              item,
                                                              "invoice_detail_description",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                          _vm.autoResize,
                                                        ],
                                                      },
                                                    })
                                                  : _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            item.invoice_detail_description,
                                                          expression:
                                                            "item.invoice_detail_description",
                                                        },
                                                      ],
                                                      ref: "description-box",
                                                      refInFor: true,
                                                      staticClass:
                                                        "form-control",
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "35px",
                                                        "min-height": "35px",
                                                        resize: "vertical",
                                                      },
                                                      domProps: {
                                                        value:
                                                          item.invoice_detail_description,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleChange(
                                                            item
                                                          )
                                                        },
                                                        input: [
                                                          function ($event) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              item,
                                                              "invoice_detail_description",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                          _vm.autoResize,
                                                        ],
                                                      },
                                                    }),
                                              ])
                                            : _c("div", {
                                                staticStyle: { padding: "5px" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    item.invoice_detail_description.replace(
                                                      /\n/g,
                                                      "<br>"
                                                    )
                                                  ),
                                                },
                                              }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.isSoumission
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap cb text-left soumission-compact-col",
                                              staticStyle: { width: "62px" },
                                            },
                                            [
                                              item.part_index === undefined
                                                ? _c("div", [
                                                    !_vm.isSoumission &&
                                                    !_vm.readOnly &&
                                                    item.invoice_detail_is_garanteed ==
                                                      0
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-left invoice_detail_parts_status_div",
                                                            },
                                                            [
                                                              _c("input", {
                                                                staticClass:
                                                                  "invoice_detail_parts_status",
                                                                attrs: {
                                                                  type: "checkbox",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    item.invoice_detail_parts_status ==
                                                                    1,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.checkboxOrderStatusChange(
                                                                        item,
                                                                        1,
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.checkboxOrderStatusChange(
                                                                          item,
                                                                          1,
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Pièces à commander"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-left invoice_detail_parts_status_div",
                                                            },
                                                            [
                                                              _c("input", {
                                                                staticClass:
                                                                  "invoice_detail_parts_status",
                                                                attrs: {
                                                                  type: "checkbox",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    item.invoice_detail_parts_status ==
                                                                    2,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.checkboxOrderStatusChange(
                                                                        item,
                                                                        2,
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.checkboxOrderStatusChange(
                                                                          item,
                                                                          2,
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Pièces commandées"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-left invoice_detail_parts_status_div",
                                                            },
                                                            [
                                                              _c("input", {
                                                                staticClass:
                                                                  "invoice_detail_parts_status",
                                                                attrs: {
                                                                  type: "checkbox",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    item.invoice_detail_parts_status ==
                                                                    3,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.checkboxOrderStatusChange(
                                                                        item,
                                                                        3,
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.checkboxOrderStatusChange(
                                                                          item,
                                                                          3,
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Pièces reçues"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ])
                                                      : !_vm.isSoumission
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-left invoice_detail_parts_status_div",
                                                            },
                                                            [
                                                              item.invoice_detail_parts_status ==
                                                              1
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "fa fa-check-square-o",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "18px",
                                                                      },
                                                                  })
                                                                : _c("i", {
                                                                    staticClass:
                                                                      "fa fa-square-o",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "18px",
                                                                      },
                                                                  }),
                                                              _vm._v(" "),
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Pièces à commander"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-left invoice_detail_parts_status_div",
                                                            },
                                                            [
                                                              item.invoice_detail_parts_status ==
                                                              2
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "fa fa-check-square-o",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "18px",
                                                                      },
                                                                  })
                                                                : _c("i", {
                                                                    staticClass:
                                                                      "fa fa-square-o",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "18px",
                                                                      },
                                                                  }),
                                                              _vm._v(" "),
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Pièces commandées"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-left invoice_detail_parts_status_div",
                                                            },
                                                            [
                                                              item.invoice_detail_parts_status ==
                                                              3
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "fa fa-check-square-o",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "18px",
                                                                      },
                                                                  })
                                                                : _c("i", {
                                                                    staticClass:
                                                                      "fa fa-square-o",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "18px",
                                                                      },
                                                                  }),
                                                              _vm._v(" "),
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Pièces reçues"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ])
                                                : !_vm.isSoumission
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class:
                                                            _vm.itemInventoryCount(
                                                              item
                                                            ) <= 0
                                                              ? "font-red"
                                                              : "font-black",
                                                          staticStyle: {
                                                            "font-weight":
                                                              "bolder",
                                                          },
                                                          attrs: {
                                                            id: "inventory",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Inventaire: " +
                                                              _vm._s(
                                                                _vm.itemInventoryCount(
                                                                  item
                                                                )
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          class:
                                                            _vm.itemReturnCount(
                                                              item
                                                            ) < 0
                                                              ? "font-red"
                                                              : "font-black",
                                                          staticStyle: {
                                                            "font-weight":
                                                              "bolder",
                                                          },
                                                          attrs: {
                                                            id: "inventory",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " RT: " +
                                                              _vm._s(
                                                                _vm.itemReturnCount(
                                                                  item
                                                                )
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "width-min-nowrap input",
                                          staticStyle: { width: "70px" },
                                        },
                                        [
                                          _c("div", [
                                            !_vm.readOnly &&
                                            item.invoice_detail_is_garanteed ==
                                              0
                                              ? _c("div", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          item.invoice_detail_qty,
                                                        expression:
                                                          "item.invoice_detail_qty",
                                                      },
                                                    ],
                                                    ref: "qty",
                                                    refInFor: true,
                                                    staticClass:
                                                      "form-control invoice_detail_qty select-on-focus",
                                                    attrs: {
                                                      id: "qty",
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value:
                                                        item.invoice_detail_qty,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleChange(
                                                          item
                                                        )
                                                      },
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          item,
                                                          "invoice_detail_qty",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "5px",
                                                      "text-align": "right",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.invoice_detail_qty
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                          ]),
                                          _vm._v(" "),
                                          item.part_index === undefined
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "5px",
                                                  },
                                                },
                                                [
                                                  !_vm.readOnly &&
                                                  item.invoice_detail_is_garanteed ==
                                                    0
                                                    ? _c("div", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                item.invoice_detail_hours,
                                                              expression:
                                                                "item.invoice_detail_hours",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control invoice_detail_hours select-on-focus",
                                                          attrs: {
                                                            type: "number",
                                                          },
                                                          domProps: {
                                                            value:
                                                              item.invoice_detail_hours,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleChange(
                                                                item
                                                              )
                                                            },
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.$set(
                                                                item,
                                                                "invoice_detail_hours",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ])
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            padding: "5px",
                                                            "text-align":
                                                              "right",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.invoice_detail_hours
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isSoumission
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap soumission-group-cell soumission-compact-col",
                                              staticStyle: {
                                                "max-width": "62px",
                                                width: "62px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "soumission-group-text",
                                                  attrs: {
                                                    title:
                                                      item.part_group_name ||
                                                      "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.part_group_name || ""
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSoumission
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap text-right soumission-compact-col",
                                              staticStyle: {
                                                "min-width": "62px",
                                                width: "62px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatSoumissionMoney(
                                                        item.suggested_price
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSoumission
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap text-right soumission-compact-col",
                                              staticStyle: {
                                                "min-width": "62px",
                                                width: "62px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatSoumissionMoney(
                                                        item.cost_price
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSoumission
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap text-right soumission-compact-col",
                                              staticStyle: {
                                                "min-width": "62px",
                                                width: "62px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatSoumissionMoney(
                                                        item.minimum_profit
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSoumission
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap text-right soumission-compact-col",
                                              staticStyle: {
                                                "min-width": "62px",
                                                width: "62px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatSoumissionPercent(
                                                        item.percent_profit
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "width-min-nowrap input",
                                          staticStyle: {
                                            width: "100px",
                                            position: "relative",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            !_vm.readOnly &&
                                            item.invoice_detail_is_garanteed ==
                                              0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      position: "relative",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          top: "6px",
                                                          right: "8px",
                                                          "font-size": "16px",
                                                          "user-select": "none",
                                                        },
                                                      },
                                                      [_vm._v("$")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            item.invoice_detail_price,
                                                          expression:
                                                            "item.invoice_detail_price",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control invoice_detail_price text-right select-on-focus",
                                                      staticStyle: {
                                                        width: "100px",
                                                        "padding-right": "20px",
                                                      },
                                                      attrs: { type: "text" },
                                                      domProps: {
                                                        value:
                                                          item.invoice_detail_price,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleChange(
                                                            item
                                                          )
                                                        },
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            item,
                                                            "invoice_detail_price",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    class:
                                                      item.invoice_detail_is_garanteed ==
                                                      1
                                                        ? "text-strikethrough"
                                                        : "",
                                                    staticStyle: {
                                                      padding: "5px",
                                                      "text-align": "right",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.invoice_detail_price
                                                        ) +
                                                        " $\n                      "
                                                    ),
                                                  ]
                                                ),
                                          ]),
                                          _vm._v(" "),
                                          item.part_index === undefined
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "5px",
                                                  },
                                                },
                                                [
                                                  !_vm.readOnly &&
                                                  item.invoice_detail_is_garanteed ==
                                                    0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            position:
                                                              "relative",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                position:
                                                                  "absolute",
                                                                top: "6px",
                                                                right: "8px",
                                                                "font-size":
                                                                  "16px",
                                                                "user-select":
                                                                  "none",
                                                                color: "#fff",
                                                              },
                                                            },
                                                            [_vm._v("$/h")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  item.invoice_detail_hour_rate,
                                                                expression:
                                                                  "item.invoice_detail_hour_rate",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control invoice_detail_hour_rate text-right select-on-focus",
                                                            staticStyle: {
                                                              width: "100px",
                                                              "padding-right":
                                                                "35px",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                            },
                                                            domProps: {
                                                              value:
                                                                item.invoice_detail_hour_rate,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleChange(
                                                                  item
                                                                )
                                                              },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.$set(
                                                                  item,
                                                                  "invoice_detail_hour_rate",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            padding: "5px",
                                                            "text-align":
                                                              "right",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.invoice_detail_hour_rate
                                                              ) +
                                                              " $/h\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isSoumission
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-min-nowrap text-right soumission-compact-col",
                                              staticStyle: {
                                                "min-width": "62px",
                                                width: "62px",
                                              },
                                            },
                                            [
                                              !_vm.readOnly &&
                                              item.invoice_detail_is_garanteed ==
                                                0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        padding: "2px",
                                                        position: "relative",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            position:
                                                              "absolute",
                                                            top: "6px",
                                                            right: "6px",
                                                            "font-size": "13px",
                                                            "user-select":
                                                              "none",
                                                          },
                                                        },
                                                        [_vm._v("%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        staticClass:
                                                          "form-control text-right select-on-focus",
                                                        staticStyle: {
                                                          width: "100%",
                                                          "padding-right":
                                                            "16px",
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          disabled:
                                                            item.part_index ===
                                                            undefined,
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.getSoumissionActualProfitPercent(
                                                              item
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.onSoumissionProfitPercentChange(
                                                              item,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        padding: "5px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getSoumissionActualProfitPercentDisplay(
                                                            item
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "width-min-nowrap text-right",
                                          class:
                                            item.invoice_detail_is_garanteed ==
                                            1
                                              ? "text-strikethrough"
                                              : "",
                                          staticStyle: { "min-width": "100px" },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getItemSubtotal(item)
                                              ) + " $"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          item.part_index === undefined
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getItemTimeSubtotal(
                                                        item
                                                      )
                                                    ) + " $"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "width-min-nowrap input soumission-compact-col",
                                          staticStyle: {
                                            width: "50px",
                                            position: "relative",
                                          },
                                        },
                                        [
                                          !_vm.readOnly &&
                                          item.invoice_detail_is_garanteed == 0
                                            ? _c("div", [
                                                item.part_index === undefined
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          top: "14px",
                                                          right: "8px",
                                                          "font-size": "16px",
                                                          "user-select": "none",
                                                        },
                                                      },
                                                      [_vm._v("$")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          top: "8px",
                                                          right: "8px",
                                                          "font-size": "16px",
                                                          "user-select": "none",
                                                        },
                                                      },
                                                      [_vm._v("$")]
                                                    ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        item.invoice_detail_tire_tax,
                                                      expression:
                                                        "item.invoice_detail_tire_tax",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-control invoice_detail_tire_tax text-right select-on-focus",
                                                  staticStyle: {
                                                    width: "50px",
                                                    "padding-right": "20px",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    disabled:
                                                      item.part_index ===
                                                      undefined,
                                                  },
                                                  domProps: {
                                                    value:
                                                      item.invoice_detail_tire_tax,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleChange(
                                                        item
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "invoice_detail_tire_tax",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ])
                                            : _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "5px",
                                                    width: "50px",
                                                    "text-align": "right",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.invoice_detail_tire_tax
                                                      ) +
                                                      " $\n                    "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "width-min-nowrap text-right",
                                          class:
                                            item.invoice_detail_is_garanteed ==
                                            1
                                              ? "text-strikethrough"
                                              : "",
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.getItemTotal(item)) +
                                                " $"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          item.part_index === undefined
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getItemTimeTotal(item)
                                                    ) + " $"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("tfoot", { staticStyle: { border: "none" } }, [
                        _c("tr", { staticStyle: { border: "none" } }, [
                          !_vm.readOnly
                            ? _c(
                                "td",
                                {
                                  staticStyle: { border: "none" },
                                  attrs: { colspan: "5" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn purple pull-left",
                                      on: { click: _vm.addService },
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-plus" }),
                                      _vm._v(" Ajouter un service"),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn purple pull-left",
                                      staticStyle: { "margin-left": "10px" },
                                      on: { click: _vm.addSubtotal },
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-plus" }),
                                      _vm._v(" Ajouter un sous-total"),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(3),
                                ]
                              )
                            : _c("td", {
                                staticStyle: { border: "none" },
                                attrs: { colspan: "3" },
                              }),
                          _vm._v(" "),
                          _vm._m(4),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                border: "none",
                                "text-align": "left",
                              },
                            },
                            [_c("b", [_vm._v(_vm._s(_vm.totalHours))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                border: "none",
                                "padding-right": "0",
                                "padding-bottom": "0",
                              },
                              attrs: { colspan: _vm.summaryTotalsColspan },
                            },
                            [
                              _c("div", [
                                _c(
                                  "table",
                                  {
                                    staticClass: "table-bordered text-right",
                                    staticStyle: { width: "100%" },
                                  },
                                  [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [_vm._v("Total sans taxes:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.round(_vm.subtotal, 2)) +
                                              " $"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [_vm._v("Montant taxable TPS:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.round(_vm.taxableTpsAmount, 2)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [
                                          _vm._v(
                                            "TPS (" +
                                              _vm._s(_vm.tpsValue) +
                                              " %):"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.round(_vm.tpsAmount, 2)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [_vm._v("Montant taxable TVQ:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.round(_vm.taxableTvqAmount, 2)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [
                                          _vm._v(
                                            "TVQ (" +
                                              _vm._s(_vm.tvqValue) +
                                              " %):"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.round(_vm.tvqAmount, 2)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "5px" } },
                                        [_vm._v("T.V. Pneu:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "min-width": "100px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.round(_vm.tireTotal, 2)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("Total:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "min-width": "100px",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.round(_vm.grandTotal, 2)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.payments,
                                      function (payment, index) {
                                        return _c("tr", { key: index }, [
                                          _c(
                                            "td",
                                            { staticStyle: { padding: "5px" } },
                                            [
                                              _vm._v(
                                                "Paiement par " +
                                                  _vm._s(
                                                    payment.payment_method_name
                                                  ) +
                                                  " le " +
                                                  _vm._s(payment.payment_date) +
                                                  ":"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "5px",
                                                "min-width": "100px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.round(
                                                    payment.payment_amount,
                                                    2
                                                  )
                                                ) + " $"
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("Montant dû:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "min-width": "100px",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.round(_vm.dueAmount, 2)
                                            ) + " $"
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  2
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tools" }, [
      _c("a", {
        staticClass: "collapse",
        attrs: {
          href: "javascript:;",
          "data-original-title": "",
          title: "Afficher / Cacher",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("span", { staticStyle: { "font-size": "22px" } }, [
        _c("i", { staticClass: "fa fa-refresh fa-spin" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("i", { staticClass: "fa fa-refresh fa-spin" }),
      _vm._v(" Rechargement des détails..."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "form-group pull-left", staticStyle: { width: "50%" } },
      [
        _c(
          "label",
          {
            staticClass: "col-sm-5 col-md-5 col-lg-5 control-label",
            staticStyle: {
              margin: "6px 0",
              padding: "0",
              "text-align": "right",
            },
            attrs: { for: "invoice_template_select" },
          },
          [_vm._v("Services prédéfinis:")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-7 col-md-7 col-lg-7" }, [
          _c("div", { staticClass: "select2-input-container input-group" }, [
            _c(
              "select",
              {
                staticClass: "form-control invoice_template_select",
                staticStyle: { width: "100%" },
                attrs: {
                  id: "invoice_template_select",
                  name: "invoice_template_select",
                },
              },
              [_c("option", { attrs: { value: "", selected: "" } })]
            ),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          border: "none",
          padding: "10px 0px",
          "text-align": "right",
        },
      },
      [_c("b", [_vm._v("Total heures: ")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }